import { MetadataItem, useSearchQueryMetadata } from '@aibees/elephant/hooks';
import { Box, CircularProgress, Typography } from '@mui/material';
import { memo } from 'react';
import type { SearchFilterOption } from '../../types';
import { CheckListFilterWithOptions } from './check-list-filter-with-options';
import * as SX from './sx';
import type { CheckListFilterProps as Props } from './types';

export const CheckListFilterWithApi = memo(
  ({ options, metadata, ...rest }: Props) => {
    const includeMetadata = !!(rest.open && metadata?.metaDataApi?.enabled);
    const api = useSearchQueryMetadata(
      metadata?.metaDataApi?.key,
      includeMetadata
    );

    const optionsFromApi = api.data.map(
      (item) =>
        ({
          ...item,
          ...{
            type: 'STRING',
            icon: null,
            index: item.value,
            selected: metadata?.checkbox?.defaultSelected,
          },
        } as unknown as SearchFilterOption & MetadataItem)
    );

    if (api.isFetching) {
      return (
        <Box sx={SX.loadingContainer}>
          <CircularProgress size={14} />
          <Typography fontSize={14}>Loading...</Typography>
        </Box>
      );
    }

    return (
      <CheckListFilterWithOptions
        options={optionsFromApi}
        metadata={metadata}
        {...rest}
      />
    );
  }
);

CheckListFilterWithApi.displayName = 'CheckListFilterWithApi';
